import axios from '@axios'

const route = 'marketing/offer'

export default {
  namespaced: true,
  state: {
    selectServices: [],
    selectProducts: [],
    selectAllServices: '',
    selectAllProducts: '',
  },
  getters: {
    getSelectServices: state => state.selectServices,
    getSelectProducts: state => state.selectProducts,
    getSelectAllServices: state => state.selectAllServices,
    getSelectAllProducts: state => state.selectAllProducts,
  },
  mutations: {
    setSelectServices(state, services) {
      state.selectServices = services
    },
    setSelectProducts(state, products) {
      state.selectProducts = products
    },
    setSelectAllServices(state, value) {
      state.selectAllServices = value
    },
    setSelectAllProducts(state, value) {
      state.selectAllProducts = value
    },
  },
  actions: {

    index(context, params) {
      return axios.get(route, { params })
    },

    saveOffer(context, data) {
      return axios.post(route, data)
    },

    updateOffer(context, data) {
      return axios.put(`${route}/${data.id}`, data)
    },

    deactivate(context, offer) {
      return axios.post(`${route}/deactivate/${offer.id}`)
    },
    active(context, offer) {
      return axios.post(`${route}/active/${offer.id}`)
    },

    destroyOffer(context, offer) {
      return axios.delete(`${route}/${offer.id}`)
    },

    clone(context, offer) {
      return axios.post(`${route}/clone/${offer.id}`)
    },

    getServices(context) {
      return axios.get('helper/get_services')
    },

    getProducts(context, offer) {
      return axios.get('helper/get_products')
    },

    // getExportExcel(constext,data) {
    //   return axios.post( route+'/export_excel',data ,{ responseType: 'blob' })
    // },

    // getExportPdf(constext,data) {
    //   return axios.post( route+'/export_pdf',data ,{ responseType: 'blob' })
    // },

  },
}
